
















import Vue from 'vue';
import { mapState } from 'vuex';
import { AppScope } from '../../../constants/appScope';
import { HotelInterface } from '../../../types/hotelInterface';

export default Vue.extend({
  name: 'HotelMainInfo',
  data() {
    return {
      titleOpen: false,
    };
  },
  computed: {
    ...mapState({
      prefectures(state: any): { [index: number]: string } {
        return this.isDashboard ? state.dashboard.settings.prefectures : state.landing.settings.prefectures;
      },
      hotel(state: any): HotelInterface {
        return (this as any).isDashboard ? state.dashboard.hotel : state.landing.hotel.item;
      },
    }),
    isDashboard(): boolean {
      const scope = this.getScope();
      return scope === AppScope.Dashboard;
    },
    hotelName(): string {
      return this.hotel.name[this.i18nTag()] ? this.hotel.name[this.i18nTag()] : this.hotel.name.en;
    },
    hotelAddress(): string {
      return this.hotel.address[this.i18nTag()] ? this.hotel.address[this.i18nTag()] : this.hotel.address.en;
    },
    hotelAddressLink(): string {
      const lat = this.hotel.latitude;
      const lng = this.hotel.longitude;
      return `dir//${lat},${lng}/@${lat},${lng},12z`;
    },
    hotelAddressFormatted(): string {
      let prefecture: any = '';
      if (this.hotel.prefecture_code) {
        prefecture = this.prefectures[this.hotel.prefecture_code];
        if (prefecture) {
          prefecture = this.$t('common.prefecture.' + prefecture);
        }
      }
      if (this.$i18n.locale === 'en') {
        return prefecture ? `${this.hotelAddress}, ${prefecture}` : this.hotelAddress;
      }
      return `${prefecture}${this.hotelAddress}`;
    },
  },
});
